import {SmartComponentManager} from "smart-component-js";
import DefaultCtrl from "./controllers/DefaultCtrl";
import HomeCtrl from "./controllers/HomeCtrl";
import FeedbackModalComponent from "./components/FeedbackModalComponent";
import VisualParallaxComponent from "./components/VisualParallaxComponent";
import ScacchieriComponent from "./components/ScacchieriComponent";
import AreaPersonaleCtrl from "./controllers/AreaPersonaleCtrl"
import CompletaDatiCtrl from "./controllers/CompletaDatiCtrl"
import ThankYouCtrl from "./controllers/ThankYouCtrl"
import $ from "jquery";
import '../less/mb-promo.less';


SmartComponentManager.registerComponents({
	DefaultCtrl,
	VisualParallaxComponent,
	FeedbackModalComponent,
	ScacchieriComponent,
	AreaPersonaleCtrl,
	CompletaDatiCtrl,
	ThankYouCtrl,
	HomeCtrl
});



$(document).ready(() => {
	let $body = $('.mb-promo');
	SmartComponentManager.initComponentByName($body[0], $body.attr('component'));
});


